import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSoundWave24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSoundWave24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M11 20.5v-17a.75.75 0 0 1 1.5 0v17a.75.75 0 0 1-1.5 0m-3-3v-11a.75.75 0 0 1 1.5 0v11a.75.75 0 0 1-1.5 0m6-11v11a.75.75 0 0 0 1.5 0v-11a.75.75 0 0 0-1.5 0M5.75 9.25a.75.75 0 0 1 .75.75v4A.75.75 0 0 1 5 14v-4a.75.75 0 0 1 .75-.75M18.5 10a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zm-15.75.75a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 .75-.75m18.75.75a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSoundWave24);
